import { Grid } from '@mui/material'
import AutoCompleteChipInput from 'components/AutoCompleteChipInput'
import { graphql, useLazyLoadQuery } from 'react-relay'
import { IndustryField_Query } from '__generated__/IndustryField_Query.graphql'
import { FormValueInput, FormValueMeta } from 'types'
import React, { forwardRef, ForwardedRef } from 'react'
import { useEdges } from 'hooks/relay'

export interface IIndustryFieldProps {
  input: FormValueInput<{ id: string, name: string }[]>
  meta: FormValueMeta
}

const IndustryField = ({ input, meta }: IIndustryFieldProps, ref: ForwardedRef<HTMLInputElement>) => {
  const data = useLazyLoadQuery<IndustryField_Query>(graphql`
    query IndustryField_Query {
      industries(first: 100) {
        edges {
          node {
            name
            id
          }
        }
      }
    }
  `, {}, {
    fetchPolicy: 'store-and-network',
  })

  const industries = useEdges(data?.industries?.edges)
  const suggestions = industries.map(u => ({ id: u.id, name: u.name })) || []

  return (
    <Grid item xs={12} md={12}>
      <AutoCompleteChipInput
        ref={ref}
        input={input}
        meta={meta}
        label="Industries"
        suggestions={suggestions}
        placeholder="Start typing industries..."
        fullWidth
      />
    </Grid>
  )
}

export default forwardRef<HTMLInputElement, IIndustryFieldProps>(IndustryField)
